/* eslint-disable react/prop-types */
import Box from '@material-ui/core/Box'
import Button from '@material-ui/core/Button'
import Grid from '@material-ui/core/Grid'
import IconButton from '@material-ui/core/IconButton'
import SearchIcon from '@material-ui/icons/Search'
import React, { useState } from 'react'
import { KeyboardDatePicker } from '@material-ui/pickers'
import { useDispatch, useSelector } from 'react-redux'
import { format } from 'date-fns'
import { InputAdornment, TextField } from '@material-ui/core'

import { makeOverdueReport, overdue, ready, readyLaundry } from '../HomeActions'
import BaseFilter from '../../../components/hooks/BaseFilter'
import Icon from '@mdi/react'
import { mdiMagnifyExpand, mdiMicrosoftExcel } from '@mdi/js'
import colors from '../../../assets/colors'
import filterStylesComponents from '../../../assets/filterComponentsStyles'

export default function OverdueItemsFilter(props) {
  const items = useSelector(state => state.dashboard.readyItems)

  const styles = filterStylesComponents()

  const dispatch = useDispatch()
  const { classes, isLaundry } = props

  const [form, setForm] = useState({
    collected_at: null,
    deadline_date: null,
    client: '',
    laundry: '',
  })

  const onSubmit = e => {
    e.preventDefault()
    const data = {
      ...form,
      collected_at: form.collected_at
        ? format(form.collected_at, 'yyyy-MM-dd HH:mm:ss')
        : null,
      deadline_date: form.deadline_date
        ? format(form.deadline_date, 'yyyy-MM-dd HH:mm:ss')
        : null,
    }

    if (isLaundry) return dispatch(readyLaundry(data))

    dispatch(overdue(data))
  }

  const handleRelatoryExport = e => {
    e.preventDefault()
    const data = {
      ...form,
      collected_at: form.collected_at
        ? format(form.collected_at, 'yyyy-MM-dd HH:mm:ss')
        : null,
      deadline_date: form.deadline_date
        ? format(form.deadline_date, 'yyyy-MM-dd HH:mm:ss')
        : null,
    }

    dispatch(makeOverdueReport(data))
  }

  return (
    <BaseFilter>
      <form onSubmit={onSubmit} style={{ width: '100%' }}>
        <Grid item xs={12}>
          <Grid container spacing={2} alignItems="flex-end">
            <Grid item sm={3}>
              <TextField
                onChange={e =>
                  setForm({ ...form, [e?.target?.name]: e.target.value })
                }
                label={isLaundry ? 'Nome da Lavanderia' : 'Nome do Cliente'}
                className={classes.inputFilter}
                fullWidth
                name={isLaundry ? 'laundry' : 'client'}
                value={isLaundry ? form.laundry : form.client}
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton onClick={onSubmit}>
                        <Icon path={mdiMagnifyExpand} size={1} />
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
            </Grid>

            <Grid item sm={3}>
              <KeyboardDatePicker
                clearable
                value={form.collected_at}
                label="Data da Coleta"
                fullWidth
                views={['date']}
                clearLabel="Limpar"
                invalidDateMessage="Data inválida"
                autoOk
                onChange={date => setForm({ ...form, collected_at: date })}
                format="dd/MM/yyyy"
              />
            </Grid>

            <Grid item xs={12} sm={3}>
              <Button
                type="submit"
                color={colors.primary}
                className={styles.btnAdd}
              >
                <SearchIcon />
                {` Pesquisar`}
              </Button>
            </Grid>

            {!isLaundry && (
              <Grid item sm>
                <Grid container justifyContent="flex-end">
                  <Grid item>
                    <IconButton
                      className={styles.btnAdd}
                      onClick={handleRelatoryExport}
                    >
                      <Icon path={mdiMicrosoftExcel} size={1} />
                      Exportar
                    </IconButton>
                  </Grid>
                </Grid>
              </Grid>
            )}
          </Grid>
        </Grid>
      </form>
    </BaseFilter>
  )
}
